import React, { Fragment } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Radio, { RadioProps } from '@material-ui/core/Radio';

const GreenRadio = withStyles({
  root: {
    color: '#00ab8a',
    '&$checked': {
      color: '#00ab8a',
    },
  },
  checked: {},
})((props: RadioProps) => <Radio color="default" {...props} />);

interface Props {
  onSelectPercentage: (value: number) => void;
}

export default function RadioButtons(props: Props) {
  const [selectedValue, setSelectedValue] = React.useState('24');

  function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    const { onSelectPercentage } = props;
    setSelectedValue(event.target.value);
    onSelectPercentage(+event.target.value);
  }

  return (
    <Fragment>
      <div className="md:flex md:items-center">
        <GreenRadio
          checked={selectedValue === '12'}
          onChange={handleChange}
          value="12"
          name="tasa"
          inputProps={{ 'aria-label': '12' }}
        />
        <span className="uppercase text-gray-700 text-xs font-bold">Conservador (12%)*</span>
      </div>
      <div className="md:flex md:items-center">
        <GreenRadio
          checked={selectedValue === '18'}
          onChange={handleChange}
          value="18"
          name="tasa"
          inputProps={{ 'aria-label': '18' }}
        />
        <span className="uppercase text-gray-700 text-xs font-bold">Moderado (18%)*</span>
      </div>
      <div className="md:flex md:items-center">
        <GreenRadio
          checked={selectedValue === '24'}
          onChange={handleChange}
          value="24"
          name="tasa"
          inputProps={{ 'aria-label': '24' }}
        />
        <span className="uppercase text-gray-700 text-xs font-bold">Aventurero (24%)*</span>
      </div>
    </Fragment>
  );
}